import { ROLES } from "@app/constants";
import { currentUser } from "@app/routes/auth/selectors";
import {
  trackReadingEvent as TRE,
  trackWordProblemEvent,
  trackcSharedPointerEvent,
  trackcRecordingStatusEvent,
  trackcDoneEvent,
} from "./reading";

import {
  setWordStateById, setFirstReadingWord, setLastReadingWord,
  setIsFollowingWords, setIsApprovedByStudent, setRecordingStatus,
  clearState, setIsApprovedByTherapist, setIsComplete,
  setEndRecording,
} from "@app/routes/activities/reading/store/readingSlice";

export const relevantReadingBeforeActions = {

};

export const relevantReadingAfterTherapistActions = {
  [setFirstReadingWord]: (stateBefore, stateAfter, boardId) => {
    TRE("reading_mark_first_word", stateAfter, boardId);
  },
  [setLastReadingWord]: (stateBefore, stateAfter, boardId) => {
    TRE("reading_mark_last_word", stateAfter, boardId);
  },
  [setIsApprovedByStudent]: (stateBefore, stateAfter, boardId) => {
    TRE("reading_approved_by_student", stateAfter, boardId);
  },
  [setIsApprovedByTherapist]: (stateBefore, stateAfter, boardId) => {
    TRE("reading_approved_by_therapist", stateAfter, boardId);
  },
  [setIsFollowingWords]: (stateBefore, stateAfter, boardId, action) => {
    trackcSharedPointerEvent(stateAfter, stateBefore, boardId, action);
  },
  [setWordStateById]: (stateBefore, stateAfter, boardId, action) => {
    trackWordProblemEvent(stateAfter, stateBefore, boardId, action);
  },
  [setRecordingStatus]: (stateBefore, stateAfter, boardId, action) => {
    trackcRecordingStatusEvent(stateAfter, stateBefore, boardId, action);
  },
  [clearState]: (stateBefore, stateAfter, boardId, action) => {
    trackcDoneEvent(stateAfter, stateBefore, boardId, action);
  },
  [setIsComplete]: (stateBefore, stateAfter, boardId) => {
    TRE("reading_clicked_done", stateAfter, boardId);
  },
  [setEndRecording]: (stateBefore, stateAfter, boardId) => {
    TRE("reading_timer_stops", stateAfter, boardId);
  },
};

export const relevantReadingAfterStudentActions = {
  [setIsApprovedByStudent]: (stateBefore, stateAfter, boardId) => {
    TRE("reading_approved_by_student", stateAfter, boardId);
  },
};

export const readingActionsRouterAfter = (stateBefore, stateAfter, action) => {
  const currUser = currentUser(stateAfter);
  const boardId = action?.payload?.boardId;

  currUser.role === ROLES.THERAPIST.id && relevantReadingAfterTherapistActions[action.type]?.(stateBefore, stateAfter, boardId, action);
  currUser.role === ROLES.STUDENT.id && relevantReadingAfterStudentActions[action.type]?.(stateBefore, stateAfter, boardId, action);
};
